import axios from "../../config/axios"

function exportTransactions (query, onDownloadProgress) {
    return axios().get("/ledger/transactions-export", { params: query, onDownloadProgress: onDownloadProgress})
}

export default {
    exportTransactions
}